// ================================================================
// DIARIO.JS - Diário de Campo
// Versão simplificada funcional - formulário e feed de atividades
// ================================================================

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.operacional = window.FazendaRP.Pages.operacional || {};

window.FazendaRP.Pages.operacional.diario = {
    container: null,
    selectedFiles: [],
    editingActivityId: null, // Track if we're editing
    filters: {
        tipo: '',
        variedade: '',
        dataInicio: '',
        dataFim: '',
        busca: ''
    },

    render: async function (container) {
        this.container = container;

        const shared = window.FazendaRP.Pages.operacional.shared;

        // Load safras for dropdown
        await shared.populateSafras();

        // Load varieties for the current safra
        await shared.loadVariedades(shared.safraAtual);
        await shared.loadMaquinas();
        await shared.loadInsumos(); // Load inputs catalog

        const insumosOptions = (shared.insumosCache || []).map(item =>
            `<option value="${item.nome}">${item.categoria ? `(${item.categoria})` : ''} - Ref: ${item.unidade || 'N/A'}</option>`
        ).join('');

        const html = `
            <div style="background: white; border-radius: 12px; padding: 25px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); margin-bottom: 20px;">
                <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
                    <div style="display:flex; align-items:center; gap:20px;">
                        <h3 style="margin:0; color:#1f2937;">
                            <i class="fas fa-pen-to-square" style="color:#059669;"></i> Diário de Campo
                        </h3>
                        
                        <!-- Safra Selector -->
                        <div style="display:flex; align-items:center; gap:10px;">
                            <label style="font-size:0.9rem; color:#6b7280; font-weight:600;">
                                <i class="fas fa-seedling" style="color:#059669;"></i> Safra:
                            </label>
                            <select id="safra-selector-diario" style="padding:8px 12px; border:1px solid #d1d5db; border-radius:6px; font-size:0.9rem; cursor:pointer; background:white;">
                                ${shared.safraOptionsHtml || `<option value="${shared.safraAtual}">${shared.safraAtual}</option>`}
                            </select>
                        </div>
                    </div>
                    
                    <button id="btn-toggle-form" class="btn-primary" style="background:#059669; color:white; border:none; padding:10px 20px; border-radius:8px; font-weight:600; cursor:pointer;">
                        <i class="fas fa-plus-circle"></i> Novo Apontamento
                    </button>
                </div>

                <div id="form-container" style="display:none; background:#f9fafb; padding:20px; border-radius:8px; margin-bottom:20px;">
                    <!-- Form will be rendered on demand -->
                </div>

                <!-- Filters Bar -->
                <div id="filters-bar" style="background:#f9fafb; padding:15px; border-radius:8px; margin-bottom:15px; border:1px solid #e5e7eb;">
                    <div style="display:grid; grid-template-columns:repeat(3, 1fr) auto; gap:10px; align-items:end;">
                        
                        <!-- Tipo de Operação -->
                        <div>
                            <label style="display:block; font-size:0.85rem; font-weight:600; margin-bottom:5px; color:#6b7280;">
                                <i class="fas fa-filter" style="color:#059669;"></i> Tipo de Operação
                            </label>
                            <select id="filter-tipo" style="width:100%; padding:8px; border:1px solid #d1d5db; border-radius:6px;">
                                <option value="">Todos</option>
                                <option value="Plantio">Plantio</option>
                                <option value="Pulverização">Pulverização</option>
                                <option value="Adubação">Adubação</option>
                                <option value="Dessecação">Dessecação</option>
                                <option value="Colheita">Colheita</option>
                            </select>
                        </div>

                        <!-- Variedade -->
                        <div>
                            <label style="display:block; font-size:0.85rem; font-weight:600; margin-bottom:5px; color:#6b7280;">
                                <i class="fas fa-seedling" style="color:#059669;"></i> Variedade
                            </label>
                            <select id="filter-variedade" style="width:100%; padding:8px; border:1px solid #d1d5db; border-radius:6px;">
                                <option value="">Todas</option>
                                ${shared.variedadesCache.map(v => `<option value="${v.id}">${v.nome}</option>`).join('')}
                            </select>
                        </div>

                        <!-- Período -->
                        <div>
                            <label style="display:block; font-size:0.85rem; font-weight:600; margin-bottom:5px; color:#6b7280;">
                                <i class="fas fa-calendar" style="color:#059669;"></i> Período
                            </label>
                            <div style="display:flex; gap:5px;">
                                <input type="date" id="filter-data-inicio" style="flex:1; padding:8px; border:1px solid #d1d5db; border-radius:6px; font-size:0.85rem;">
                                <span style="align-self:center; color:#6b7280; font-size:0.85rem;">até</span>
                                <input type="date" id="filter-data-fim" style="flex:1; padding:8px; border:1px solid #d1d5db; border-radius:6px; font-size:0.85rem;">
                            </div>
                        </div>

                        <!-- Botões de Ação -->
                        <div style="display:flex; gap:5px; flex-wrap:wrap;">
                            <button id="btn-limpar-filtros" style="background:#6b7280; color:white; border:none; padding:10px 14px; border-radius:6px; cursor:pointer; font-weight:600; font-size:0.85rem;" title="Limpar Filtros">
                                <i class="fas fa-times"></i>
                            </button>
                            <button onclick="window.FazendaRP.Pages.operacional.exports.exportAtividadesExcel(window.FazendaRP.Pages.operacional.diario.filters)" 
                                    style="background:#10b981; color:white; border:none; padding:10px 14px; border-radius:6px; cursor:pointer; font-weight:600; font-size:0.85rem;" title="Exportar para Excel">
                                <i class="fas fa-file-excel"></i>
                            </button>
                            <button onclick="window.FazendaRP.Pages.operacional.exports.exportRelatorioAtividadesPDF(window.FazendaRP.Pages.operacional.diario.filters)" 
                                    style="background:#dc2626; color:white; border:none; padding:10px 14px; border-radius:6px; cursor:pointer; font-weight:600; font-size:0.85rem;" title="Relatório PDF">
                                <i class="fas fa-file-pdf"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Busca por Texto -->
                    <div style="margin-top:10px;">
                        <input type="text" id="filter-busca" placeholder="🔍 Buscar nas observações..." 
                               style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:6px;">
                    </div>
                </div>

                <div id="activities-feed">
                    <div style="text-align:center; padding:40px; color:#9ca3af;">
                        <i class="fas fa-circle-notch fa-spin"></i> Carregando atividades...
                    </div>
                </div>
            </div>
        `;

        container.innerHTML = html;
        this.setupEvents();
        this.loadActivities();
    },

    renderForm: function () {
        const shared = window.FazendaRP.Pages.operacional.shared;
        const today = new Date().toISOString().split('T')[0];

        // Check if varieties are loaded
        let variedadesCheckboxes = '';
        if (!shared.variedadesCache || shared.variedadesCache.length === 0) {
            variedadesCheckboxes = `
                <div style="padding:20px; text-align:center; background:#fff3cd; border:1px solid #ffc107; border-radius:8px; color:#856404;">
                    <i class="fas fa-exclamation-triangle" style="font-size:2rem; margin-bottom:10px; display:block;"></i>
                    <strong>Nenhuma variedade encontrada</strong>
                    <p style="margin:10px 0 0 0; font-size:0.9rem;">
                        Você precisa cadastrar variedades em <strong>Sistema > Safras</strong> antes de criar atividades.
                    </p>
                </div>
            `;
        } else {
            variedadesCheckboxes = shared.variedadesCache.map(v => `
                <label style="display:inline-flex; align-items:center; gap:8px; padding:8px 12px; background:white; border:1px solid #d1d5db; border-radius:20px; cursor:pointer; margin:5px;">
                    <input type="checkbox" name="variedades" value="${v.id}" data-area="${v.area_hectares}" style="accent-color:#059669;">
                    <span>${v.nome} (${v.area_hectares}ha)</span>
                </label>
            `).join('');
        }

        const maquinasOptions = shared.maquinasCache.map(m =>
            `<option value="${m.id}">${m.nome} ${m.modelo ? '- ' + m.modelo : ''}</option>`
        ).join('');

        // Generate Insumos Datalist (Robust)
        const insumosOptions = (shared.insumosCache || []).map(item =>
            `<option value="${item.nome}">${item.categoria ? `(${item.categoria})` : ''} - Ref: ${item.unidade || 'N/A'}</option>`
        ).join('');

        return `
            <datalist id="datalist-insumos-v3-unique">
                ${insumosOptions}
            </datalist>

            <form id="form-atividade" onsubmit="window.FazendaRP.Pages.operacional.diario.saveAtividade(event); return false;">
                
                <!-- Informações Básicas -->
                <div style="display:grid; grid-template-columns:1fr 1fr 1fr 1fr 1fr; gap:15px; margin-bottom:20px;">
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">Data de Início *</label>
                        <input type="date" name="data_inicio" value="${today}" required style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px; font-size:0.95rem;">
                    </div>
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">Data de Fim *</label>
                        <input type="date" name="data_fim" value="${today}" required style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px; font-size:0.95rem;">
                    </div>
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">Tipo de Operação *</label>
                        <select name="tipo" required style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px; font-size:0.95rem;">
                            <option value="">-- Selecione --</option>
                            <option value="Pulverização">Pulverização</option>
                            <option value="Plantio">Plantio</option>
                            <option value="Adubação">Adubação</option>
                            <option value="Colheita">Colheita</option>
                            <option value="Vistoria">Vistoria</option>
                            <option value="Dessecação">Dessecação</option>
                            <option value="Irrigação">Irrigação</option>
                        </select>
                    </div>
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">Estádio Fenológico</label>
                        <select name="estadio" style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px; font-size:0.95rem;">
                            <option value="">-- Não se aplica --</option>
                            <optgroup label="Vegetativo">
                                <option value="VE">VE - Emergência</option>
                                <option value="VC">VC - Cotilédones</option>
                                <option value="V1">V1 - 1ª Folha Trifoliada</option>
                                <option value="V2">V2 - 2ª Folha Trifoliada</option>
                                <option value="V3">V3 - 3ª Folha Trifoliada</option>
                                <option value="V4">V4 - 4ª Folha Trifoliada</option>
                                <option value="V5">V5 - 5ª Folha Trifoliada</option>
                                <option value="V6">V6 - 6ª Folha Trifoliada</option>
                                <option value="V7">V7 - 7ª Folha Trifoliada</option>
                                <option value="V8">V8 - 8ª Folha Trifoliada</option>
                                <option value="V9">V9 - 9ª Folha Trifoliada</option>
                                <option value="V10">V10 - 10ª Folha Trifoliada</option>
                                <option value="VN">VN - Última Folha Trifoliada</option>
                            </optgroup>
                            <optgroup label="Reprodutivo">
                                <option value="R1">R1 - Início Floração</option>
                                <option value="R2">R2 - Floração Plena</option>
                                <option value="R3">R3 - Início Formação Vagens</option>
                                <option value="R4">R4 - Vagens Desenvolvidas</option>
                                <option value="R5.1">R5.1 - Início Enchimento Grãos</option>
                                <option value="R5.2">R5.2 - Enchimento Grãos 25%</option>
                                <option value="R5.3">R5.3 - Enchimento Grãos 50%</option>
                                <option value="R5.4">R5.4 - Enchimento Grãos 75%</option>
                                <option value="R5.5">R5.5 - Enchimento Grãos 100%</option>
                                <option value="R6">R6 - Grãos Cheios</option>
                                <option value="R7">R7 - Maturação Fisiológica</option>
                                <option value="R8">R8 - Maturação de Colheita</option>
                                <option value="R9">R9 - Ponto de Colheita</option>
                            </optgroup>
                        </select>
                    </div>
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">Máquina</label>
                        <select name="maquina" style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px; font-size:0.95rem;">
                            <option value="">-- Nenhuma --</option>
                            ${maquinasOptions}
                        </select>
                    </div>
                </div>

                <!-- Variedades -->
                <div style="background:#f9fafb; padding:20px; border-radius:10px; margin-bottom:20px; border:1px solid #e5e7eb;">
                    <label style="display:block; font-weight:700; margin-bottom:12px; color:#1f2937; font-size:1rem;">
                        <i class="fas fa-seedling" style="color:#059669;"></i> Aplicar em quais Variedades? *
                    </label>
                    <div style="display:flex; flex-wrap:wrap; gap:8px;">
                        ${variedadesCheckboxes}
                    </div>
                    <div id="area-total-display" style="margin-top:12px; padding:10px; background:white; border-radius:6px; font-weight:600; color:#059669; display:none;">
                        Área Total Selecionada: <span id="area-total-value">0</span> ha
                    </div>
                </div>

                <!-- Operador e Custo -->
                <div style="display:grid; grid-template-columns:1fr 1fr 1fr; gap:15px; margin-bottom:20px;">
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">Operador/Responsável</label>
                        <input type="text" name="operador" placeholder="Ex: José Silva" style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px; font-size:0.95rem;">
                    </div>
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">Área Real Aplicada (ha)</label>
                        <input type="number" step="0.01" name="area_aplicada" placeholder="Ex: 90.5" oninput="window.FazendaRP.Pages.operacional.diario.recalculateAllRows()" style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px; font-size:0.95rem;">
                    </div>
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">💰 Custo da Aplicação (R$)</label>
                        <input type="number" step="0.01" name="custo_total" id="input-custo" placeholder="0.00" style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px; font-size:0.95rem;">
                        <small id="custo-hint" style="color:#6b7280; font-size:0.75rem; display:none;">Estimado: R$ <span id="custo-estimado-value">0</span></small>
                    </div>
                </div>

                <!-- Insumos/Produtos -->
                <div style="background:#f0fdf4; padding:20px; border-radius:10px; margin-bottom:20px; border:2px dashed #059669;">
                    <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:15px;">
                        <label style="font-weight:700; color:#1f2937; font-size:1rem;">
                            <i class="fas fa-flask" style="color:#059669;"></i> Insumos / Produtos Aplicados
                        </label>
                        <button type="button" onclick="window.FazendaRP.Pages.operacional.diario.addInsumoRow()" style="background:#059669; color:white; border:none; padding:8px 16px; border-radius:6px; font-weight:600; cursor:pointer; font-size:0.85rem;">
                            <i class="fas fa-plus"></i> Adicionar Insumo
                        </button>
                    </div>
                    <div id="insumos-container">
                        <div style="text-align:center; padding:30px; color:#9ca3af; font-size:0.9rem;">
                            <i class="fas fa-flask" style="font-size:2rem; display:block; margin-bottom:10px; color:#d1d5db;"></i>
                            <!-- Debug/Feedback -->
                            <div style="font-size:0.8rem; color:#6b7280; text-align:right; margin-bottom:5px;">
                                ${shared.insumosCache && shared.insumosCache.length > 0
                ? `<span style="color:#059669;">✔️ ${shared.insumosCache.length} produtos carregados</span>`
                : `<span style="color:#ef4444;">⚠️ Nenhum produto carregado</span>`
            }
                            </div>
                            Nenhum insumo adicionado. Clique em "Adicionar Insumo" para começar.
                        </div>
                    </div>
                </div>

                <!-- Upload de Fotos -->
                <div style="background:#eff6ff; padding:20px; border-radius:10px; margin-bottom:20px; border:2px dashed #3b82f6;">
                    <label style="display:block; font-weight:700; margin-bottom:12px; color:#1f2937; font-size:1rem;">
                        <i class="fas fa-camera" style="color:#3b82f6;"></i> Fotos / Anexos
                    </label>
                    <input type="file" name="fotos" multiple accept="image/*" onchange="window.FazendaRP.Pages.operacional.diario.handleFileSelect(event)" style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px; background:white;">
                    <div id="preview-fotos" style="display:grid; grid-template-columns:repeat(auto-fill, minmax(100px, 1fr)); gap:10px; margin-top:15px;"></div>
                </div>

                <!-- Observações -->
                <div style="margin-bottom:20px;">
                    <label style="display:block; font-weight:600; margin-bottom:8px; font-size:0.9rem; color:#374151;">Observações</label>
                    <textarea name="obs" rows="4" style="width:100%; padding:12px; border:1px solid #d1d5db; border-radius:8px; font-size:0.95rem; resize:vertical;" placeholder="Descreva detalhes da atividade, condições climáticas, ocorrências..."></textarea>
                </div>

                <!-- Botões -->
                <div style="display:flex; gap:12px; justify-content:flex-end; padding-top:20px; border-top:2px solid #e5e7eb;">
                    <button type="button" id="btn-cancel-form" style="background:#f3f4f6; color:#4b5563; border:1px solid #d1d5db; padding:12px 24px; border-radius:8px; font-weight:600; cursor:pointer;">
                        <i class="fas fa-times"></i> Cancelar
                    </button>
                    <button type="submit" style="background:linear-gradient(135deg, #059669, #047857); color:white; border:none; padding:12px 24px; border-radius:8px; font-weight:600; cursor:pointer; box-shadow:0 2px 4px rgba(5,150,105,0.3);">
                        <i class="fas fa-save"></i> Salvar Atividade
                    </button>
                </div>
            </form>

            <script>
                // Atualizar área total quando selecionar variedades
                document.querySelectorAll('input[name="variedades"]').forEach(cb => {
                    cb.addEventListener('change', () => {
                        const selected = document.querySelectorAll('input[name="variedades"]:checked');
                        const totalArea = Array.from(selected).reduce((sum, el) => sum + parseFloat(el.dataset.area || 0), 0);
                        const value = document.getElementById('area-total-value');
                        // Auto-fill Area Real input
                        const areaInput = document.querySelector('input[name="area_aplicada"]');
                        if (areaInput) {
                            areaInput.value = totalArea.toFixed(2);
                            // Trigger recalc
                            window.FazendaRP.Pages.operacional.diario.recalculateAllRows();
                        }

                        if (selected.length > 0) {
                            display.style.display = 'block';
                            value.textContent = totalArea.toFixed(1);
                        } else {
                            display.style.display = 'none';
                        }
                    });
                });
            </script>
        `;
    },

    addInsumoRow: function () {
        const container = document.getElementById('insumos-container');

        // Remove empty message if exists
        if (container.innerHTML.includes('Nenhum insumo')) {
            container.innerHTML = '';
        }

        const rowId = 'insumo-' + Date.now();
        const html = `
            <div id="${rowId}" class="insumo-row" style="background:white; padding:15px; border-radius:8px; margin-bottom:10px; border:1px solid #e5e7eb;">
                <div style="display:grid; grid-template-columns:2fr 1fr 1fr 1fr 1fr auto; gap:10px; align-items:end;">
                    <div>
                        <label style="display:block; font-size:0.8rem; font-weight:600; margin-bottom:5px; color:#6b7280;">Produto/Insumo</label>
                        <input type="text" class="insumo-nome" list="datalist-insumos-v3-unique" placeholder="Ex: Glifosato..." required style="width:100%; padding:8px; border:1px solid #d1d5db; border-radius:6px;">
                        <input type="hidden" class="insumo-custo-unit" value="0">
                    </div>
                    <div>
                        <label style="display:block; font-size:0.8rem; font-weight:600; margin-bottom:5px; color:#6b7280;">Dose/ha</label>
                        <input type="number" step="0.01" class="insumo-dose" placeholder="0.00" required style="width:100%; padding:8px; border:1px solid #d1d5db; border-radius:6px;">
                    </div>
                    <div>
                        <label style="display:block; font-size:0.8rem; font-weight:600; margin-bottom:5px; color:#6b7280;">Unidade</label>
                        <select class="insumo-unidade" style="width:100%; padding:8px; border:1px solid #d1d5db; border-radius:6px;">
                            <option value="L/ha">L/ha</option>
                            <option value="kg/ha">kg/ha</option>
                            <option value="g/ha">g/ha</option>
                            <option value="ml/ha">ml/ha</option>
                        </select>
                    </div>
                    <div>
                        <label style="display:block; font-size:0.8rem; font-weight:600; margin-bottom:5px; color:#6b7280;">Qtd. Total</label>
                        <input type="number" step="0.01" class="insumo-qtd-total" placeholder="0" readonly style="width:100%; padding:8px; border:1px solid #e5e7eb; border-radius:6px; background:#f9fafb; color:#374151; font-weight:600;">
                    </div>
                     <div>
                        <label style="display:block; font-size:0.8rem; font-weight:600; margin-bottom:5px; color:#6b7280;">Custo (Estim)</label>
                        <input type="text" class="insumo-custo-total-display" placeholder="R$ 0,00" readonly style="width:100%; padding:8px; border:1px solid #e5e7eb; border-radius:6px; background:#f0fdf4; color:#059669; font-weight:600;">
                    </div>
                    <div>
                        <button type="button" onclick="document.getElementById('${rowId}').remove(); window.FazendaRP.Pages.operacional.diario.calculateTotals();" style="background:#ef4444; color:white; border:none; padding:8px 12px; border-radius:6px; cursor:pointer;">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
        `;

        container.insertAdjacentHTML('beforeend', html);

        // Add event listeners for this new row
        const row = document.getElementById(rowId);
        const inputNome = row.querySelector('.insumo-nome');
        const inputDose = row.querySelector('.insumo-dose');
        const inputUnidade = row.querySelector('.insumo-unidade');

        // When product changes -> Fetch Price & Unit
        inputNome.addEventListener('change', (e) => {
            const val = e.target.value;
            const shared = window.FazendaRP.Pages.operacional.shared;
            const item = (shared.insumosCache || []).find(i => i.nome === val);

            if (item) {
                // Set Cost
                row.querySelector('.insumo-custo-unit').value = item.custo_medio || 0;

                // Set Unit if possible
                if (item.unidade) {
                    if (item.unidade.toLowerCase().includes('l')) inputUnidade.value = 'L/ha';
                    else if (item.unidade.toLowerCase().includes('kg')) inputUnidade.value = 'kg/ha';
                }

                this.recalculateRow(rowId);
            }
        });

        inputDose.addEventListener('input', () => this.recalculateRow(rowId));
    },

    recalculateRow: function (rowId) {
        const row = document.getElementById(rowId);
        if (!row) return;

        const inputDose = row.querySelector('.insumo-dose');
        const custoUnit = parseFloat(row.querySelector('.insumo-custo-unit').value) || 0;

        // Get Area from the Main Input "Área Real Aplicada"
        const areaInput = document.querySelector('input[name="area_aplicada"]');
        const totalArea = parseFloat(areaInput ? areaInput.value : 0) || 0;
        const dose = parseFloat(inputDose.value) || 0;

        // Calc Quantity
        const qtdTotal = dose * totalArea;
        row.querySelector('.insumo-qtd-total').value = qtdTotal.toFixed(2);

        // Calc Cost
        const custoTotal = qtdTotal * custoUnit;
        row.querySelector('.insumo-custo-total-display').value = custoTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        // Recalculate Grand Total
        this.calculateTotals();
    },

    recalculateAllRows: function () {
        document.querySelectorAll('.insumo-row').forEach(row => {
            this.recalculateRow(row.id);
        });
    },

    calculateTotals: function () {
        // Sum all rows cost
        let totalCost = 0;
        document.querySelectorAll('.insumo-row').forEach(row => {
            const qtd = parseFloat(row.querySelector('.insumo-qtd-total').value) || 0;
            const unitCost = parseFloat(row.querySelector('.insumo-custo-unit').value) || 0;
            totalCost += (qtd * unitCost);
        });

        const inputCusto = document.getElementById('input-custo');
        if (inputCusto) {
            const hint = document.getElementById('custo-estimado-value');
            if (hint) {
                hint.textContent = totalCost.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                hint.parentElement.style.display = 'block';
            }
            // Auto-fill if empty or previously auto-filled (we could track this, but simplifying)
            // if (inputCusto.value == '' || inputCusto.value == '0') {
            inputCusto.value = totalCost.toFixed(2);
            // }
        }
    },

    handleFileSelect: function (event) {
        const files = event.target.files;
        const preview = document.getElementById('preview-fotos');
        preview.innerHTML = '';

        Array.from(files).forEach((file, idx) => {
            const reader = new FileReader();
            reader.onload = function (e) {
                const div = document.createElement('div');
                div.style.cssText = 'position:relative; border-radius:8px; overflow:hidden; border:2px solid #e5e7eb;';
                div.innerHTML = `
                    <img src="${e.target.result}" style="width:100%; height:100px; object-fit:cover;">
                    <div style="position:absolute; bottom:0; left:0; right:0; background:rgba(0,0,0,0.6); color:white; padding:4px; text-align:center; font-size:0.7rem;">
                        Foto ${idx + 1}
                    </div>
                `;
                preview.appendChild(div);
            };
            reader.readAsDataURL(file);
        });

        this.selectedFiles = Array.from(files);
    },

    setupEvents: function () {
        const btnToggle = document.getElementById('btn-toggle-form');
        const formContainer = document.getElementById('form-container');
        const btnCancel = document.getElementById('btn-cancel-form');
        const safraSelector = document.getElementById('safra-selector-diario');

        // Safra selector change event
        if (safraSelector) {
            safraSelector.addEventListener('change', async (e) => {
                const novaSafra = e.target.value;
                console.log(`🔄 Mudando para safra: ${novaSafra}`);

                const shared = window.FazendaRP.Pages.operacional.shared;
                shared.variedadesCache = []; // Clear cache
                await shared.loadVariedades(novaSafra);

                // If form is open, re-render it with new varieties
                if (formContainer.style.display !== 'none') {
                    formContainer.innerHTML = this.renderForm();
                }

                // Reload feed
                this.loadActivities();

                console.log(`✅ Safra alterada para: ${novaSafra}`);
                window.FazendaRP.Toast?.show('success', 'Safra Alterada', `Agora trabalhando com safra ${novaSafra}`);
            });
        }

        if (btnToggle) {
            btnToggle.addEventListener('click', async () => {
                if (formContainer.style.display === 'none') {
                    // Show loading state
                    btnToggle.disabled = true;
                    btnToggle.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Carregando...';

                    // Ensure varieties and insumos are loaded
                    const shared = window.FazendaRP.Pages.operacional.shared;
                    if (!shared.variedadesCache || shared.variedadesCache.length === 0) {
                        await shared.loadVariedades(shared.safraAtual);
                    }
                    await shared.loadInsumos(); // Force load/check inputs

                    // Render form
                    formContainer.innerHTML = this.renderForm();
                    formContainer.style.display = 'block';
                    btnToggle.innerHTML = '<i class="fas fa-times"></i> Cancelar';
                    btnToggle.style.background = '#6b7280';
                    btnToggle.disabled = false;
                } else {
                    formContainer.style.display = 'none';
                    btnToggle.innerHTML = '<i class="fas fa-plus-circle"></i> Novo Apontamento';
                    btnToggle.style.background = '#059669';
                }
            });
        }

        if (btnCancel) {
            btnCancel.addEventListener('click', () => {
                formContainer.style.display = 'none';
                btnToggle.innerHTML = '<i class="fas fa-plus-circle"></i> Novo Apontamento';
                btnToggle.style.background = '#059669';
            });
        }

        // Setup Filter Events
        this.setupFilterEvents();
    },

    setupFilterEvents: function () {
        const filterTipo = document.getElementById('filter-tipo');
        const filterVariedade = document.getElementById('filter-variedade');
        const filterDataInicio = document.getElementById('filter-data-inicio');
        const filterDataFim = document.getElementById('filter-data-fim');
        const filterBusca = document.getElementById('filter-busca');
        const btnLimpar = document.getElementById('btn-limpar-filtros');

        // Dropdowns - apply immediately
        if (filterTipo) {
            filterTipo.addEventListener('change', () => {
                this.filters.tipo = filterTipo.value;
                this.loadActivities();
            });
        }

        if (filterVariedade) {
            filterVariedade.addEventListener('change', () => {
                this.filters.variedade = filterVariedade.value;
                this.loadActivities();
            });
        }

        // Dates - apply on change
        if (filterDataInicio) {
            filterDataInicio.addEventListener('change', () => {
                this.filters.dataInicio = filterDataInicio.value;
                this.loadActivities();
            });
        }

        if (filterDataFim) {
            filterDataFim.addEventListener('change', () => {
                this.filters.dataFim = filterDataFim.value;
                this.loadActivities();
            });
        }

        // Search - debounce 500ms
        if (filterBusca) {
            let timeout;
            filterBusca.addEventListener('input', (e) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    this.filters.busca = e.target.value;
                    this.loadActivities();
                }, 500);
            });
        }

        // Clear filters
        if (btnLimpar) {
            btnLimpar.addEventListener('click', () => {
                this.filters = { tipo: '', variedade: '', dataInicio: '', dataFim: '', busca: '' };
                if (filterTipo) filterTipo.value = '';
                if (filterVariedade) filterVariedade.value = '';
                if (filterDataInicio) filterDataInicio.value = '';
                if (filterDataFim) filterDataFim.value = '';
                if (filterBusca) filterBusca.value = '';
                this.loadActivities();
            });
        }
    },

    saveAtividade: async function (e) {
        e.preventDefault();
        const form = e.target;
        const btn = form.querySelector('button[type="submit"]');

        btn.disabled = true;
        btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Salvando...';

        // Get selected variedades
        const variedades = [];
        form.querySelectorAll('input[name="variedades"]:checked').forEach(c => variedades.push(c.value));

        if (variedades.length === 0) {
            alert('Selecione pelo menos uma variedade');
            btn.disabled = false;
            btn.innerHTML = this.editingActivityId ? '<i class="fas fa-save"></i> Atualizar Atividade' : '<i class="fas fa-save"></i> Salvar Atividade';
            return;
        }

        // Upload de fotos (se houver)
        let fotosUrls = [];
        const fotoInput = form.querySelector('input[name="fotos"]'); // FIX: usar name ao invés de ID
        if (fotoInput && fotoInput.files.length > 0) {
            btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Fazendo upload de fotos...';
            try {
                fotosUrls = await window.FazendaRP.PhotoUpload.uploadPhotos(fotoInput.files, 'atividades');
                console.log('✅ Upload concluído:', fotosUrls.length, 'fotos');
            } catch (err) {
                console.error('Erro no upload de fotos:', err);
                alert('Erro ao fazer upload das fotos. A atividade será salva sem as fotos.');
            }
        }

        // Coletar insumos
        const insumos = [];
        document.querySelectorAll('#insumos-container > div[id^="insumo-"]').forEach(row => {
            const nome = row.querySelector('.insumo-nome')?.value;
            const dose = parseFloat(row.querySelector('.insumo-dose')?.value || 0);
            const unidade = row.querySelector('.insumo-unidade')?.value;

            if (nome && dose > 0) {
                insumos.push({ nome, dose, unidade });
            }
        });

        const payload = {
            data_atividade: form.data_inicio.value,
            data_fim: form.data_fim.value,
            tipo_operacao: form.tipo.value,
            estadio_fenologico: form.estadio?.value || null,
            variedades_ids: variedades,
            maquina_id: form.maquina.value || null,
            operador: form.operador?.value || null,
            area_aplicada: parseFloat(form.area_aplicada?.value) || null,
            custo_total: parseFloat(form.custo_total?.value) || null,
            observacoes: form.obs.value,
            insumos: insumos,
            anexos_urls: fotosUrls // Corrigido para bater com a tabela operacional_atividades
        };

        try {
            btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Salvando no banco...';

            let error;
            if (this.editingActivityId) {
                // UPDATE existing activity
                ({ error } = await window.FazendaRP.supabase
                    .from('operacional_atividades')
                    .update(payload)
                    .eq('id', this.editingActivityId));
            } else {
                // INSERT new activity
                ({ error } = await window.FazendaRP.supabase
                    .from('operacional_atividades')
                    .insert([payload]));
            }

            if (error) throw error;

            const message = this.editingActivityId ? 'Atividade atualizada!' : 'Atividade registrada!';
            const fotosMsg = fotosUrls.length > 0 ? ` (${fotosUrls.length} foto${fotosUrls.length > 1 ? 's' : ''} anexada${fotosUrls.length > 1 ? 's' : ''})` : '';
            window.FazendaRP.Toast.show('success', 'Sucesso', message + fotosMsg);

            form.reset();
            this.selectedFiles = [];
            this.editingActivityId = null;
            document.getElementById('form-container').style.display = 'none';
            document.getElementById('btn-toggle-form').innerHTML = '<i class="fas fa-plus-circle"></i> Novo Apontamento';
            document.getElementById('btn-toggle-form').style.background = '#059669';

            this.loadActivities();

        } catch (err) {
            console.error(err);
            alert('Erro ao salvar: ' + err.message);
        } finally {
            btn.disabled = false;
            btn.innerHTML = this.editingActivityId ? '<i class="fas fa-save"></i> Atualizar Atividade' : '<i class="fas fa-save"></i> Salvar Atividade';
        }
    },

    editarAtividade: async function (id) {
        try {
            // Fetch activity data
            const { data, error } = await window.FazendaRP.supabase
                .from('operacional_atividades')
                .select('*')
                .eq('id', id)
                .single();

            if (error) throw error;

            // Set editing mode
            this.editingActivityId = id;

            // Open form
            const formContainer = document.getElementById('form-container');
            const btnToggle = document.getElementById('btn-toggle-form');

            formContainer.innerHTML = this.renderForm();
            formContainer.style.display = 'block';
            btnToggle.innerHTML = '<i class="fas fa-times"></i> Cancelar';
            btnToggle.style.background = '#6b7280';

            // Pre-fill form
            const form = document.getElementById('form-atividade');
            if (!form) return;

            form.data_inicio.value = data.data_atividade;
            form.data_fim.value = data.data_fim || data.data_atividade;
            form.tipo.value = data.tipo_operacao || '';
            form.maquina.value = data.maquina_id || '';
            form.obs.value = data.observacoes || '';

            // Check selected variedades
            if (data.variedades_ids && Array.isArray(data.variedades_ids)) {
                data.variedades_ids.forEach(vid => {
                    const checkbox = form.querySelector(`input[name="variedades"][value="${vid}"]`);
                    if (checkbox) checkbox.checked = true;
                });
            }

            // Change button text
            const submitBtn = form.querySelector('button[type="submit"]');
            if (submitBtn) {
                submitBtn.innerHTML = '<i class="fas fa-save"></i> Atualizar Atividade';
            }

            // Scroll to form
            formContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });

        } catch (err) {
            console.error('Erro ao carregar atividade:', err);
            alert('Erro ao carregar atividade: ' + err.message);
        }
    },

    excluirAtividade: async function (id) {
        if (!confirm('Tem certeza que deseja excluir esta atividade? Esta ação não pode ser desfeita.')) {
            return;
        }

        try {
            const { error } = await window.FazendaRP.supabase
                .from('operacional_atividades')
                .delete()
                .eq('id', id);

            if (error) throw error;

            window.FazendaRP.Toast.show('success', 'Excluído', 'Atividade excluída com sucesso!');
            this.loadActivities();

        } catch (err) {
            console.error('Erro ao excluir:', err);
            alert('Erro ao excluir atividade: ' + err.message);
        }
    },

    loadActivities: async function () {
        const feed = document.getElementById('activities-feed');
        if (!feed) return;

        try {
            // Base query
            let query = window.FazendaRP.supabase
                .from('operacional_atividades')
                .select('*');

            // Apply filters
            if (this.filters.tipo) {
                query = query.eq('tipo_operacao', this.filters.tipo);
            }

            if (this.filters.variedade) {
                query = query.contains('variedades_ids', [this.filters.variedade]);
            }

            if (this.filters.dataInicio) {
                query = query.gte('data_atividade', this.filters.dataInicio);
            }

            if (this.filters.dataFim) {
                query = query.lte('data_atividade', this.filters.dataFim);
            }

            if (this.filters.busca) {
                query = query.ilike('observacoes', `%${this.filters.busca}%`);
            }

            // Order and limit
            query = query.order('data_atividade', { ascending: false }).limit(50);

            const { data, error } = await query;

            if (error) throw error;

            if (!data || data.length === 0) {
                feed.innerHTML = `
                    <div style="text-align:center; padding:60px; background:#f9fafb; border-radius:12px; border:2px dashed #e5e7eb;">
                        <i class="fas fa-clipboard-list" style="font-size:3rem; color:#d1d5db; margin-bottom:15px;"></i>
                        <h4 style="margin:0; color:#4b5563;">Nenhuma atividade encontrada</h4>
                        <p style="color:#9ca3af; margin-top:5px;">Ajuste os filtros ou use o botão "Novo Apontamento" para começar.</p>
                    </div>
                `;
                return;
            }

            const shared = window.FazendaRP.Pages.operacional.shared;
            const html = data.map(act => {
                const dateDisplay = shared.formatDateRange(act.data_atividade, act.data_fim);

                // Render fotos galeria
                let fotosHtml = '';
                if (act.fotos && act.fotos.length > 0) {
                    fotosHtml = `
                        <div style="margin-top:15px; padding-top:15px; border-top:1px solid #e5e7eb;">
                            <div style="font-weight:600; font-size:0.85rem; color:#6b7280; margin-bottom:10px;">
                                <i class="fas fa-camera"></i> Fotos (${act.fotos.length})
                            </div>
                            <div style="display:grid; grid-template-columns:repeat(auto-fill, minmax(100px, 1fr)); gap:8px;">
                                ${act.fotos.map(url => `
                                    <img src="${url}" 
                                         onclick="window.open('${url}', '_blank')"
                                         style="width:100%; height:80px; object-fit:cover; border-radius:8px; cursor:pointer; border:2px solid #e5e7eb; transition:all 0.2s;"
                                         onmouseover="this.style.transform='scale(1.05)'; this.style.borderColor='#3b82f6';"
                                   onmouseout="this.style.transform='scale(1)'; this.style.borderColor='#e5e7eb';">
                                `).join('')}
                            </div>
                        </div>
                    `;
                }

                // Render insumos
                let insumosHtml = '';
                if (act.insumos && act.insumos.length > 0) {
                    insumosHtml = `
                        <div style="margin-top:15px; padding-top:15px; border-top:1px solid #e5e7eb;">
                            <div style="font-weight:600; font-size:0.85rem; color:#6b7280; margin-bottom:8px;">
                                <i class="fas fa-flask"></i> Insumos Aplicados
                            </div>
                            <div style="display:grid; gap:5px;">
                                ${act.insumos.map(ins => `
                                    <div style="background:#f9fafb; padding:6px 10px; border-radius:6px; font-size:0.8rem; display:flex; justify-content:space-between;">
                                        <span style="font-weight:500;">${ins.nome}</span>
                                        <span style="color:#6b7280;">${ins.dose} ${ins.unidade}</span>
                                    </div>
                                `).join('')}
                            </div>
                        </div>
                    `;
                }

                return `
                    <div style="background:white; border-left:4px solid #3b82f6; padding:20px; border-radius:10px; margin-bottom:15px; box-shadow:0 1px 3px rgba(0,0,0,0.05);">
                        <div style="display:flex; justify-content:space-between; margin-bottom:10px;">
                            <div>
                                <div style="font-weight:700; font-size:1rem; color:#1f2937; margin-bottom:5px;">${act.tipo_operacao}</div>
                                <div style="font-size:0.85rem; color:#6b7280;">
                                    <i class="fas fa-calendar"></i> ${dateDisplay}
                                </div>
                            </div>
                            <div style="display:flex; gap:8px;">
                                <button onclick="window.FazendaRP.Pages.operacional.diario.editarAtividade('${act.id}')" 
                                        style="background:#3b82f6; color:white; border:none; padding:6px 12px; border-radius:6px; cursor:pointer; font-size:0.85rem;">
                                    <i class="fas fa-edit"></i> Editar
                                </button>
                                <button onclick="window.FazendaRP.Pages.operacional.diario.excluirAtividade('${act.id}')" 
                                        style="background:#ef4444; color:white; border:none; padding:6px 12px; border-radius:6px; cursor:pointer; font-size:0.85rem;">
                                    <i class="fas fa-trash"></i> Excluir
                                </button>
                            </div>
                        </div>
                        <p style="margin:10px 0; color:#4b5563; font-size:0.9rem;">${act.observacoes || 'Sem observações'}</p>
                        ${insumosHtml}
                        ${fotosHtml}
                    </div>
                `;
            }).join('');

            feed.innerHTML = html;

        } catch (err) {
            console.error(err);
            feed.innerHTML = '<div style="color:red; text-align:center; padding:20px;">Erro ao carregar atividades</div>';
        }
    }
};
